import { render, staticRenderFns } from "./NormalMulti1.vue?vue&type=template&id=18b0aaa3&"
import script from "./NormalMulti1.vue?vue&type=script&lang=js&"
export * from "./NormalMulti1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports